import Resources from './resources';

export default function (dispatch, showAction, hideAction) {
    const env = Resources.env;

    function requestInterceptor() {
        dispatch(showAction());
    }

    function responseInterceptor(response) {
        const action = env.havePendingRequests() ? showAction() : hideAction();

        dispatch(action);

        return response;
    }

    env.addRequestInterceptor(requestInterceptor);
    env.addResponseInterceptor(responseInterceptor);
}



// WEBPACK FOOTER //
// ./helpers/busy-indicator-interceptor.js